import { Component, Input } from '@angular/core';
import { Spettacolo } from '../../shared/interface';

@Component({
  selector: 'app-date-spettacolo',
  templateUrl: './date-spettacolo.component.html',
  styleUrl: './date-spettacolo.component.css'
})
export class DateSpettacoloComponent {

  @Input() spettacolo?: Spettacolo;
  @Input() colore: string = 'dark';

  calculateDateDiff(dal: string | Date | undefined, al: string | Date | undefined) {
    let date_dal = new Date(dal!);
    let date_al = new Date(al!);
    return Math.floor((Date.UTC(date_al.getFullYear(), date_al.getMonth(), date_al.getDate()) - Date.UTC(date_dal.getFullYear(), date_dal.getMonth(), date_dal.getDate())) / (1000 * 60 * 60 * 24));
  }
}
